import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment';
import { api } from '@/api/index';
import Element from 'element-ui';
import directive from './directive'; // directive

Vue.use(directive)
//全局关闭弹窗点击外部关闭
Element.Dialog.props.closeOnClickModal.default = false

import './assets/common.scss'

//打印组件
import KrPrintDesigner from "kr-print-designer";
import "kr-print-designer/lib/kr-print-designer.css";

Vue.use(KrPrintDesigner);

import '@/assets/styles/normalize.css'; // A modern alternative to CSS resets
import 'element-ui/packages/theme-chalk/src/index.scss';
import '@/assets/styles/index.scss'; // global css
import '@/assets/styles/ruoyi.scss'; // global css

//权限控制
import './permission'
import { checkAppVersion, setupVersionVisibilityCheck } from '@/utils/versionCheck'
Vue.prototype.$moment = moment;
Vue.prototype.$Api = api;
Vue.config.productionTip = false

// 发版缓存检测：启动 + 回到前台
checkAppVersion()
setupVersionVisibilityCheck()

import { parseTime,addDateRange } from "@/utils/ruoyi";
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import DictData from '@/components/DictData'
// 全局方法挂载
Vue.prototype.addDateRange = addDateRange
Vue.prototype.parseTime = parseTime

// 全局组件挂载
Vue.component('DictTag', DictTag)
DictData.install()

//输入框使用的组件
import shipmentNo from '@/components/input/shipmentNo'
Vue.component('ShipmentNo', shipmentNo)

Vue.use(Element);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
